import classes from './typography.module.css';

type MonospaceProps = {
  children: React.ReactNode;
};

export const Monospace = ({ children }: MonospaceProps) => {
  return <div className={classes.monoSpace}>{children}</div>;
};
